const zh = {
  kicker: "面向企业与市政府",
  title: "把您的地点放上巨魔地图。",
  lead: "家庭、徒步者和游客沿着峡湾追寻巨魔。赞助属于您的巨魔，自选它们的位置，让寻宝之旅把游客直接带到您门前——您的酒店、咖啡馆、桑拿、乐园，甚至整个市镇。",
  launchBadge: "首发优惠 · 前 50 位支持者享 5 折",
  ctaPackages: "查看套餐",
  ctaContact: "与我们洽谈",
  mockPin: "您的商家在这里",
  mockVipps: "用 Vipps 预订",
  mockNear: "附近有巨魔 · 2 分钟",
  whyKicker: "为什么成为支持者",
  whyTitle: "一场把路人变成客人的寻宝游戏。",
  why: [
    { h: "游客主动上门", p: "每个巨魔都是一个目的地。玩家步行、滑雪、骑车去寻找它——这意味着有人来到您门前，准备停留、用餐、住宿和消费。" },
    { h: "标注在地图上", p: "您的地点会和专属巨魔一起标注在巨魔地图上。探索者会发现他们自己永远找不到的有趣去处。" },
    { h: "Vipps 预订", p: "客人可以在应用中向您预订并用 Vipps 付款——一杯咖啡、一份华夫饼、一个桑拿时段或一张门票——到店即可享用。" },
    { h: "全年四季", p: "极光下滑雪、午夜阳光篝火、复活节驯鹿和秋季采蘑菇。寻宝让游客一年四季源源不断。" },
    { h: "面向全世界", p: "游戏支持挪威语、北萨米语、英语、中文、俄语和泰语，您的地点既能吸引本地家庭，也能吸引国际游客。" },
    { h: "您的标志登上我们的网站", p: "支持者的标志和链接会展示在我们的网站上，就在每位玩家都会看到的 App Store 和 Google Play 按钮下方。" },
  ],
  forKicker: "适合",
  forTitle: "所有值得绕道一游的地方。",
  forList: ["市镇与地区", "旅游局", "酒店与小屋", "餐厅与咖啡馆", "面包店", "桑拿与水疗", "景点与活动乐园", "步道与滑雪中心", "旅行社", "俱乐部与协会", "商店与农场商店", "露营地"],
  pkgKicker: "支持者套餐",
  pkgTitle: "选择您想要的巨魔数量。",
  pkgLead: "为期一年，巨魔放在您指定的位置，每年可续订。巨魔越多，每个巨魔的价格越低。",
  launchNote: "前 50 位支持者享首发价——常规价格的 5 折。",
  perYear: "每年 · 不含增值税",
  regular: "常规价格",
  perTroll: "每个巨魔 {price} 克朗",
  trolls: "{n} 个巨魔",
  troll: "1 个巨魔",
  popular: "最受欢迎",
  choose: "选择{name}",
  packages: {
    local: { name: "本地", for: "咖啡馆、面包店、桑拿和小商店", perks: ["门前 1 个巨魔", "您的地点在应用中标注", "Vipps 预订"] },
    business: { name: "企业", for: "餐厅、酒店和活动经营者", perks: ["您的地点放置 5 个巨魔", "自选巨魔类型", "Vipps 预订", "在我们网站展示标志和链接"] },
    destination: { name: "目的地", for: "景点乐园、度假村和步道网络", perks: ["整个区域 10 个巨魔", "自选巨魔类型", "Vipps 预订", "在我们网站展示标志和链接"] },
    region: { name: "市镇", for: "市镇、地区和旅游局", perks: ["整个市镇 20 个巨魔", "专属巨魔路线", "为本地商家提供 Vipps 预订", "在我们网站展示标志和链接"] },
  },
  custom: "需要 20 个以上的巨魔、多个市镇或一条全新的步道？我们与您一起打造定制巨魔路线。",
  customCta: "咨询定制路线",
  customName: "定制路线",
  cityKicker: "市镇与旅游",
  cityTitle: "希望吸引更多游客的城市和市镇——这是给您的邀请。",
  cityBody: [
    "太多游客只是开车路过。巨魔寻宝给了他们停下来的理由，多住一晚，探索那个著名拍照点之外的地方。",
    "有了专属巨魔路线，您可以把游客分散到村庄、步道、商店和咖啡馆——把本地故事、自然和商家变成一场全家都想完成的游戏。",
  ],
  cityPoints: ["更多过夜和更长的停留", "为本地商家带来客流，淡季也不例外", "家庭、巴士团、徒步者和滑雪者", "展示自然与文化的现代户外活动"],
  cityCta: "洽谈合作",
  stepsKicker: "合作流程",
  stepsTitle: "四步，从想法到巨魔。",
  steps: [
    { h: "联系我们", p: "介绍您的地点以及您感兴趣的套餐。" },
    { h: "发送地点", p: "发送带坐标的地点清单，以及每个地点想要的巨魔类型。" },
    { h: "我们设计并放置", p: "我们设计巨魔、标注在地图上，并设置您的信息页和 Vipps 预订。" },
    { h: "游客找到您", p: "您的巨魔在应用中上线。每年续订——随时可以增加更多巨魔。" },
  ],
  faqTitle: "企业常见问题",
  faq: [
    ["我们可以精确选择巨魔的位置吗？", "可以。您把带坐标的位置发给我们——门前、乐园里或步道沿线——我们就把巨魔放在那里。"],
    ["我们可以选择巨魔的样子吗？", "您可以为每个地点选择巨魔类型，例如为面包店选面包师巨魔，为桑拿选桑拿巨魔。我们会以 Trollfossjakten 的水彩风格绘制。"],
    ["Vipps 预订如何运作？", "找到您巨魔的玩家可以在应用中向您预订并用 Vipps 付款。可预订的内容由您决定。"],
    ["套餐有效期多久？", "自巨魔上线之日起一年，每年可续订。首发价适用于前 50 位支持者。"],
    ["价格含增值税吗？", "不含。所有价格均为每年价格，不含增值税（eks. mva）。"],
  ],
  finalTitle: "准备好把您的地点放上地图了吗？",
  finalBody: "联系我们，我们会为您找到合适的套餐——或为您的市镇打造定制巨魔路线。",
  finalCta: "联系我们",
};

export default zh;
